import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import locale from '../locale';

class FilterSelect extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.select = React.createRef();

        this.state = {
            selected: false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps || !this.props.value || prevProps.value.value != this.props.value.value) {
            this.select.current.select.setValue({ value: this.props.value.value });
        }
    }

    componentDidMount() {
        if (this.select && this.props.value) {
            if (this.props.value.value !== '-') {
                this.select.current.select.setValue({ value: this.props.value.value });
            }
        }
    }

    /**
     * Change handler for react-select elements
     * 
     * @param {object} value 
     * @param {object} event 
     */
    onChange(value, event) {
        let selected = (value && value.value != "-");
        this.setState({ selected });

        if (value && value.value == "-") {
            this.select.current.select.clearValue();
        }

        this.props.onChange(value, event);
    }

    render() {
        let title = locale[this.props.type];

        let titleClass = ['title'];
        if (this.state.selected) titleClass.push('selected');

        return (
            <div className="select">
                <span className={titleClass.join(' ')}>
                    {title}
                </span>

                <Select
                    ref={this.select}
                    classNamePrefix="react-select"
                    className={this.state.selected ? 'selected' : ''}
                    placeholder=""
                    isSearchable={false}
                    {...this.props}
                    onChange={this.onChange.bind(this)}
                />
            </div>
        );
    }

}



FilterSelect.propTypes = {
    type: PropTypes.string.isRequired
};

export default FilterSelect;
